// 判断数据类型
function getType(obj) {
  var type = typeof obj;
  if (type != "object") {
    return type;
  }
  return Object.prototype.toString
    .call(obj)
    .replace(/^\[object (\S+)\]$/, "$1");
}

// 封装时间转换
export const dateChange = function(time, type) {
  var mouth, day, hours, minutes, seconds;
  if (getType(time) === "Date") {
  } else if (getType(time) === "number") {
    time = new Date(time);
  } else if (getType(time) === "string" || getType(time) === "Null") {
    return "";
  }
  mouth = time.getMonth() + 1;
  day = time.getDate();
  hours = time.getHours();
  minutes = time.getMinutes();
  seconds = time.getSeconds();
  mouth < 10 ? (mouth = "0" + mouth) : mouth;
  day < 10 ? (day = "0" + day) : day;
  hours < 10 ? (hours = "0" + hours) : "0" + hours;
  minutes < 10 ? (minutes = "0" + minutes) : "0" + minutes;
  seconds < 10 ? (seconds = "0" + seconds) : "0" + seconds;
  if (type === 1) {
    return time.getFullYear() + "-" + mouth + "-" + day;
  } else if (type === 2) {
    return (
      time.getFullYear() +
      "-" +
      mouth +
      "-" +
      day +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds
    );
  }
};

//设置本日、本周、本月的返回日期
export const getToday = function(type, dates, types) {
  var now = new Date();
  var nowTime = now.getTime();
  var day = now.getDay() - 1;
  var hour = now.getHours();
  var minute = now.getMinutes();
  var ss = now.getSeconds();
  var longTime = 24 * 60 * 60 * 1000; //一天的毫秒数
  var n = longTime * 24 * (dates || 0);
  if (type == "s") {
    var dd =
      nowTime - n - hour * 60 * 60 * 1000 - minute * 60 * 1000 - ss * 1000; //获取今日零时
  }
  if (type == "e") {
    var dd = nowTime - n;
    // var dd = nowTime - n - hour * 60 * 60 * 1000 - minute * 60 * 1000 - ss * 1000; //获取今日零时
  }
  function p(s) {
    return s < 10 ? "0" + s : s;
  }
  dd = new Date(dd);
  var y = dd.getFullYear();
  var m = dd.getMonth()+1 ;
  var d = dd.getDate() - 1;
  console.log(m)
  var days = new Date(y,m-1,0);  
  if (d == 0) {
    d= days.getDate()
    m=m-1
  }
  if (types == "end") {
    var hh = 23;
    var mm = 59;
    var ss = 59;
  } else {
    var hh = dd.getHours();
    var mm = dd.getMinutes();
    var ss = dd.getSeconds();
  }
  var day =
    y + "-" + p(m) + "-" + p(d) + " " + p(hh) + ":" + p(mm) + ":" + p(ss);
  //	if(window.screen.width >= 1280 && window.screen.width < 1366){
  //		var day = y + "-" + p(m) + "-" + p(d) + " " + p(hh) + ":" + p(mm)
  //	}else if(window.screen.width >= 1366){
  //		var day = y + "-" + p(m) + "-" + p(d) + " " + p(hh) + ":" + p(mm) + ":" + p(ss);
  ////		$('.monitor_query>div:first-child>span>input').width('125px');
  //	}
  return day;
};

export const getMonday = function(type, dates) {
  var now = new Date();
  var nowTime = now.getTime();
  var day = now.getDay();
  day = day === 0 ? 7 : day;
  var longTime = 24 * 60 * 60 * 1000;
  var n = longTime * 7 * (dates || 0);
  if (type == "s") {
    var dd = nowTime - (day - 1) * longTime + n;
  }
  if (type == "e") {
    var dd = nowTime + (7 - day) * longTime + n;
  }

  function p(s) {
    return s < 10 ? "0" + s : s;
  }
  dd = new Date(dd);
  var y = dd.getFullYear();
  console.log(y);
  var m = dd.getMonth();
  if (m == 0) {
    y = y - 1;
    m = 12;
  }
  var d = dd.getDate() + 1;
  var day = y + "-" + p(m) + "-" + p(d) + " 00:00:00";
  //	if(window.screen.width >= 1280 && window.screen.width < 1366){
  //		var day = y + "-" + p(m) + "-" + p(d) + ' 00:00';
  //	}else if(window.screen.width >= 1366){
  //		var day = y + "-" + p(m) + "-" + p(d) + ' 00:00:00';
  ////		$('.monitor_query>div:first-child>span>input').width('125px');
  //	}
  return day;
};

export const getMonth = function(type, months) {
  var d = new Date();
  var year = d.getFullYear() - 1;
  console.log(year);
  var month = d.getMonth() + 1;
  if (Math.abs(months) > 12) {
    months = months % 12;
  }
  if (months != 0) {
    if (month + months > 12) {
      year++;
      month = (month + months) % 12;
    } else if (month + months < 1) {
      year--;
      month = 12 + month + months;
    } else {
      month = month + months;
    }
  }
  month = month < 10 ? "0" + month : month;
  var date = d.getDate();
  var firstday = year + "-" + month + "-" + "01";
  var lastday = "";
  if (
    month == "01" ||
    month == "03" ||
    month == "05" ||
    month == "07" ||
    month == "08" ||
    month == "10" ||
    month == "12"
  ) {
    lastday = year + "-" + month + "-" + 31;
  } else if (month == "02") {
    if (
      (year % 4 == 0 && year % 100 != 0) ||
      (year % 100 == 0 && year % 400 == 0)
    ) {
      lastday = year + "-" + month + "-" + 29;
    } else {
      lastday = year + "-" + month + "-" + 28;
    }
  } else {
    lastday = year + "-" + month + "-" + 30;
  }
  var day = "";
  if (type == "s") {
    day = firstday + " 00:00:00";
    //		if(window.screen.width >= 1280 && window.screen.width < 1366){
    //			day = firstday + " 00:00";
    //		}else if(window.screen.width >= 1366){
    //			day = firstday + " 00:00:00";
    ////			$('.monitor_query>div:first-child>span>input').width('125px');
    //		}
  } else {
    day = lastday + " 00:00:00";
  }
  console.log(day);
  return day;
};

// 哈希颜色转rgb颜色
export const colorRgb = function(color, opacity) {
  // 16进制颜色值的正则
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 把颜色值变成小写
  color = color.toLowerCase();
  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      var colorNew = "#";
      for (var i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // 处理六位的颜色值，转为RGB
    var colorChange = [];
    for (var i = 1; i < 7; i += 2) {
      colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
    }
    if (opacity || opacity === 0) {
      return "rgba(" + colorChange.join(",") + "," + opacity + ")";
    } else {
      return "rgb(" + colorChange.join(",") + ")";
    }
  } else {
    return color;
  }
};



//////////////////
// WEBPACK FOOTER
// ./static/js/date.js
// module id = null
// module chunks = 